module.exports = __webpack_public_path__ + "static/media/COS_COOPER_SCHOLL.aaaa466c.png";